module.exports = __webpack_public_path__ + "img/green_107.71b2cde6.png";